<template>
  <div class="c-searchRecruiting">
    <c-checkbox
      v-model="innerValue"
      size="is-small"
    >
      募集中の仕事のみ
    </c-checkbox>
  </div>
</template>
<script>
export default {
  name: 'SearchRecruiting',
  props: {
    value: {
      type: Boolean,
      defaut: false
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .checkbox {
  width: 100%;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  font-size: 13px;
}

.c-searchRecruiting {
}
</style>
